import { initializeApp } from 'firebase/app';

const firebaseConfig = {
  apiKey: "AIzaSyCoZam77EfvxWiyu1R2IEaQjQ4Tl19VAlc",
  authDomain: "notepad-56a6a.firebaseapp.com",
  projectId: "notepad-56a6a",
  storageBucket: "notepad-56a6a.firebasestorage.app",
  messagingSenderId: "667137513139",
  appId: "1:667137513139:web:f1a212540ffda072a002c6",
};

export const app = initializeApp(firebaseConfig);
